"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const styles = require('./Grid.module.scss');
const Grid = (_a) => {
    var { children, classes = {}, container } = _a, rest = __rest(_a, ["children", "classes", "container"]);
    return (react_1.default.createElement(Grid_1.default, Object.assign({}, rest, { classes: Object.assign(Object.assign({}, classes), { item: (0, classnames_1.default)(styles.item, {
                [styles.noPadding]: !children,
            }, classes.item) }), container: container, spacing: container ? 3 : undefined }), children));
};
exports.default = Grid;
//# sourceMappingURL=Grid.js.map